import { Button, ButtonProps } from 'antd'
import { Menu } from 'govwell-ui'

import useDisclosure from 'src/hooks/use-disclosure'
import { renderActionItemAsMenuItem } from 'src/hooks/use-make-action-item'

import Icon from '../govwell-ui/components/Icon'
import { IconKey } from '../govwell-ui/components/Icon/util'
import { ActionItem } from '../govwell-ui/types'

interface Props {
  items: ActionItem[]
  id?: string
  icon?: IconKey
  buttonType?: ButtonProps['type']
  buttonSize?: ButtonProps['size']
  title?: string
}
export const EllipsisButton = (props: Props) => {
  const { items, id, icon, buttonSize, buttonType, title = 'More' } = props
  const { isOpen, open, close } = useDisclosure()

  return (
    <>
      <Menu isOpen={isOpen} onClose={close} onOpen={open}>
        <Menu.Trigger>
          <Button
            id={id}
            onClick={(e) => e.stopPropagation()}
            size={buttonSize || 'small'}
            icon={<Icon icon={icon || 'FaChevronDown'} />}
            type={buttonType}
          >
            {!icon && title}
          </Button>
        </Menu.Trigger>
        <Menu.Content align="end" side="bottom">
          {items.map(renderActionItemAsMenuItem)}
        </Menu.Content>
      </Menu>
    </>
  )
}
